import type { JobLeg } from '../types/database';
import { parseGeoPoint } from '../utils/formatters';
import { timeStringToMinutes } from '../utils/scheduleConflict';
import type { ScheduleLegInput } from './types';

const DEFAULT_PICKUP = { lat: -33.8688, lng: 151.2093 };

export function jobLegToScheduleInput(
  leg: JobLeg,
  jobId: string,
  label?: string
): ScheduleLegInput | null {
  const pickup = leg.pickup_geopoint ? parseGeoPoint(leg.pickup_geopoint) : null;
  const dropoff = leg.dropoff_geopoint ? parseGeoPoint(leg.dropoff_geopoint) : null;
  if (!pickup || !dropoff) return null;

  return {
    jobId,
    legId: leg.id,
    legType: leg.leg_type,
    label: label ?? `Leg ${leg.sequence}`,
    pickup,
    dropoff,
    earliestStartMinutes: timeStringToMinutes(leg.earliest_start),
    latestStartMinutes: leg.latest_start
      ? timeStringToMinutes(leg.latest_start)
      : timeStringToMinutes(leg.earliest_start),
    serviceDurationMinutes: leg.service_duration_minutes,
    endTimeMinutes: leg.end_time ? timeStringToMinutes(leg.end_time) : undefined,
  };
}

export function jobLegsToScheduleInputs(
  legs: JobLeg[],
  jobId: string,
  jobTitle?: string
): ScheduleLegInput[] {
  const sorted = [...legs].sort((a, b) => a.sequence - b.sequence);
  const result: ScheduleLegInput[] = [];
  for (const leg of sorted) {
    const input = jobLegToScheduleInput(leg, jobId, `${jobTitle ?? jobId} #${leg.sequence}`);
    if (input) result.push(input);
  }
  return result;
}

export function fallbackGeoPoint(): { lat: number; lng: number } {
  return { ...DEFAULT_PICKUP };
}
